export const TAB_ACTIVE_BG = 'var(--app-bg-panel)'
export const TAB_ACTIVE_SHADOW = '0px 1px 3px rgba(17, 21, 26, 0.06)'
export const TEXT_ACTIVE = 'var(--app-text-primary)'
export const TEXT_INACTIVE = 'var(--app-text-secondary)'

export const APPEARANCE = {
  default: {
    trackBg: 'var(--app-bg-hover)',
    trackRadiusPx: 10,
    tabRadiusPx: 10,
    tabFontSize: '12px',
    tabLineHeight: '20px',
    trackMinHeight: 34,
    tabMinHeight: 28,
    tabPadding: '4px 8px',
    activeBg: TAB_ACTIVE_BG,
    activeShadow: TAB_ACTIVE_SHADOW,
    textActive: TEXT_ACTIVE,
    textInactive: TEXT_INACTIVE,
  },
  toolkit: {
    trackBg: 'var(--app-bg-hover)',
    trackRadiusPx: 16,
    tabRadiusPx: 16,
    tabFontSize: '12px',
    tabLineHeight: '24px',
  },
  // Schedules / Pulse: pill track on the DO Catalog scale, from the frame.
  // 26px overall — a 20px segment inside the track's 3px padding — and the
  // active pill carries a hairline as well as its lift, as the frame draws it.
  pulse: {
    trackBg: 'var(--app-do-field)',
    trackRadiusPx: 24,
    tabRadiusPx: 24,
    tabFontSize: 'var(--app-font-size-sm)',
    tabLineHeight: '18px',
    trackMinHeight: 26,
    tabMinHeight: 20,
    tabPadding: '1px 8px',
    activeBg: 'var(--app-do-tab-active)',
    activeShadow: '0 0 0 0.5px var(--app-border-light), 0 1px 2px rgba(17, 21, 26, 0.04)',
    textActive: 'var(--app-do-ink-label)',
    textInactive: 'var(--app-do-ink-strong)',
  },
  pulse32: {
    trackBg: 'var(--app-do-field)',
    trackRadiusPx: 24,
    tabRadiusPx: 24,
    tabFontSize: 'var(--app-font-size-sm)',
    tabLineHeight: '18px',
    trackMinHeight: 32,
    tabMinHeight: 26,
    tabPadding: '1px 8px',
    activeBg: 'var(--app-do-tab-active)',
    activeShadow: '0 0 0 0.5px var(--app-border-light), 0 1px 2px rgba(17, 21, 26, 0.04)',
    textActive: 'var(--app-do-ink-label)',
    textInactive: 'var(--app-do-ink-strong)',
  },
}
